const createUniqueItemsValidator = () => {
  let items = [];

  return {
    setItems: (newItems) => {
      items = [...newItems];
    },
    checkIfUnique: (item) => !items.includes(item),
  };
};

export const uniquePassportValidator = createUniqueItemsValidator();
export const uniqueSocCardValidator = createUniqueItemsValidator();
